"use client";

import React from "react";
import { Search, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Link } from "@/components/common/Link";
export default function PremiumVisualsHero() {
  return <section data-section-id="224501" id="water-damage-restoration-pueblo-co" className="dark bg-background text-foreground relative w-full min-h-[80vh] flex items-center justify-center overflow-hidden py-24 lg:py-32">
      {}
      <div className="absolute inset-0 z-0 overflow-hidden pointer-events-none">
        <div className="absolute inset-0 bg-gradient-to-r from-background via-background/80 to-transparent z-10" />
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1680241/img/pueblo_emergency_restoration_van.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1680241/img/pueblo_emergency_restoration_van.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1680241/img/pueblo_emergency_restoration_van.png-wvc-sizes" alt="Emergency restoration vehicle in Pueblo" className="w-full h-full object-cover opacity-40 scale-110 animate-[pulse_8s_ease-in-out_infinite] mix-blend-luminosity" loading="lazy" />
        {}
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,transparent_0%,var(--background)_100%)] z-10" />
      </div>

      {}
      <div className="relative z-20 container mx-auto px-4 flex flex-col items-center text-center max-w-5xl">
        {}
        <div className="inline-flex items-center gap-2 px-3 py-1 rounded-md bg-primary/10 border border-primary/20 backdrop-blur-md mb-8">
          <Sparkles className="w-4 h-4 text-primary" />
          <span className="text-sm font-default font-semibold text-primary tracking-wider uppercase">
            24/7 Emergency Dispatch Active
          </span>
        </div>

        <p className="text-lg md:text-xl text-muted-foreground mb-6 max-w-2xl mx-auto font-default">
          One call connects you with a certified local restoration professional — 24 hours a day, 7 days a week. Average on-site arrival: 45 minutes or less.
        </p>

        {}
        <h1 className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-default font-black tracking-tighter mb-8 leading-[1.1] uppercase">
          <span className="bg-gradient-to-br from-white via-gray-100 to-gray-400 bg-clip-text text-transparent">
            Water Damage Restoration Pueblo CO
          </span>
          <br />
          <span className="bg-gradient-to-br from-secondary via-secondary/80 to-secondary/60 bg-clip-text text-transparent">
            Fast Emergency Response 24/7
          </span>
        </h1>

        <div className="w-full max-w-2xl bg-secondary/5 border-l-4 border-secondary p-6 mb-12 rounded-md backdrop-blur-sm text-left">
          <p className="text-sm md:text-base text-foreground/90 font-default leading-relaxed">
            <span className="font-bold text-secondary uppercase tracking-wider block mb-1">About Our Service:</span>
            Pueblo Water Damage Restoration is a free referral service. When you call, we connect you with a vetted, independent local restoration professional in your area — typically on-site within 45 minutes.
          </p>
        </div>

        {}
        <div className="w-full max-w-2xl relative mb-12 group">
          <div className="absolute -inset-1 bg-gradient-to-r from-primary/30 to-secondary/30 rounded-lg blur opacity-50 group-hover:opacity-75 transition duration-500"></div>
          <div className="relative flex items-center">
            <Search className="absolute left-6 w-6 h-6 text-muted-foreground z-10" />
            <Input type="text" placeholder="Enter your address for immediate help..." className="w-full h-16 sm:h-18 pl-16 pr-36 rounded-md bg-background/60 border-white/10 backdrop-blur-xl text-lg text-white placeholder:text-muted-foreground focus-visible:ring-secondary focus-visible:border-secondary transition-all shadow-2xl" />
            <div className="absolute right-2 top-2 bottom-2">
              <Button asChild size="lg" className="h-full rounded-md px-8 bg-primary text-primary-foreground hover:bg-primary/90 font-bold text-base shadow-lg transition-transform active:scale-95">
                <Link to="tel:+1-719-470-2769">Call 24/7</Link>
              </Button>
            </div>
          </div>
        </div>

        {}
        <div className="flex flex-col sm:flex-row items-center gap-4 sm:gap-6">
          <Button asChild size="lg" className="w-full sm:w-auto rounded-md px-8 h-14 text-base font-bold bg-primary text-primary-foreground hover:bg-primary/90">
            <Link to="/ContactPage">Call Now: 45 Min Arrival</Link>
          </Button>
          <Button asChild variant="outline" size="lg" className="w-full sm:w-auto rounded-md px-8 h-14 text-base font-bold border-white/20 bg-white/5 hover:bg-white/10 text-white backdrop-blur-md">
            <Link to="/ServicesPage">Our Restoration Services</Link>
          </Button>
        </div>

        {}
        <div className="mt-16 pt-8 border-t border-white/10 flex flex-wrap justify-center gap-8 text-sm text-muted-foreground font-default font-medium uppercase tracking-widest">
          <div className="flex items-center gap-2">
            <div className="w-2 h-2 rounded-md bg-primary animate-pulse"></div>
            Arrival in 45 Minutes or Less
          </div>
          <div className="flex items-center gap-2">
            <div className="w-2 h-2 rounded-md bg-secondary"></div>
            24/7 Emergency Response
          </div>
          <div className="flex items-center gap-2">
            <div className="w-2 h-2 rounded-md bg-white/40"></div>
            Local Pueblo Experts
          </div>
        </div>
      </div>
    </section>;
}